import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"

export const ContactFetch = (url) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .get(url)
        .then((response) => {          
          let res = Middleware("ContactFetch", "fetch", response)
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("ContactFetch", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const ContactCustomformFields = () => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .get(`/contactfields/fetch`)
        .then((response) => {
          let res = Middleware("ContactCustomform", "fetch", response)    
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("ContactCustomform", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const AsterContact = (skipdata) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/contact/fetchsearch?skip=${skipdata.skip}&take=${skipdata.take}`).then(response => {
        let res = Middleware("AsterContact", "fetch", response)          
        resolve(res);
      })
      .catch((err) => {
        let res = Middleware("AsterContact", "fetch", err.response.data, "catch")
        reject(res);
      })
    })
  }
}

export const contactSearch = (skipdata) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/contact/fetchsearch?value=${skipdata.value}&skip=${skipdata.skip}&take=${skipdata.take}`).then(response => {
        let res = Middleware("contactSearch", "fetch", response)          
        if (res.statusCode === 204) {
          res.data = []
        }
        resolve(res);
      })
      .catch((err) => {
        let res = Middleware("contactSearch", "fetch", err.response.data, "catch")
        reject(res);
      })
    })
  }
};

export const fetchCountry = (payload) => {

  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/country/fetch?agent=true&country_id=&state_id=`).then(response => {
        let res = Middleware("fetchCountry", "fetch", response)          
        resolve(res);
      })
      .catch((err) => {
        let res = Middleware("fetchCountry", "fetch", err.response.data, "catch")
        reject(res);
      })
    })
  }
}

export const fetchState = (value) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/country/fetch?agent=true&country_id=${value}&state_id=`).then(response => {
        let res = Middleware("fetchState", "fetch", response)          
        resolve(res);
      })
      .catch((err) => {
        let res = Middleware("fetchState", "fetch", err.response.data, "catch")
        reject(res);
      })
    })
  }
}

export const fetchCity = (value) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/country/fetch?agent=true&country_id=&state_id=${value}`).then(response => {
        let res = Middleware("fetchCity", "fetch", response)          
        resolve(res);
      })
      .catch((err) => {
        let res = Middleware("fetchCity", "fetch", err.response.data, "catch")
        reject(res);
      })
    })
  }
}

export const contactCreate = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .post(`/contact/create`, payload)
        .then((response) => {
          let res = Middleware("contactCreate", "create", response)          
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("contactCreate", "create", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const ContactUpdate = (ticket_id, payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .put(`/contact/update/${ticket_id}`, payload)
        .then((response) => {
          let res = Middleware("ContactUpdate", "update", response)          
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("ContactUpdate", "update", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const FetchTemplate = (url) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .get(url)
        .then((response) => {
          let res = Middleware("FetchTemplate", "fetch", response)          
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("FetchTemplate", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const GetAsterCustommoduleData = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {

      await api
        .post("/formbuilder/aster/form/fetch" + payload.url, payload.bodydata)
        .then((response) => {
          let res = Middleware("CustommoduleData", "fetch", response)         
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("CustommoduleData", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};